import React, { useEffect } from "react";

import { Navigate, Outlet, useLocation } from "react-router-dom";

import { withCookies, useCookies } from "react-cookie";

const ProtectedRoute = () => {
    const [cookie, setCookie, removeCookie] = useCookies([
        "token",
        "user",
        "url",
    ]);

    const { pathname } = useLocation();
    useEffect(() => {
        if (!cookie.url) {
            setCookie("url", pathname, { path: "/" });
        }
        return () => {
            removeCookie(["url"], {
                path: "/",
            });
        };
    }, []);

    return cookie.token ? <Outlet /> : <Navigate to="/" />;
};

export default ProtectedRoute;
